<template>
  <weui-cell :text="date" :tips="content" :link="{ name: 'course.view', params: { id: course.id } }" />
</template>

<script>
import { WeuiCell } from '@/components/weui';
import { COURSE_TYPE_TRAINER, COURSE_TYPE_TRAINER_SELF } from '@/constants/types';

import formatters from '@/utils/formatter';

export default {
    props: {
        course: {
            type: Object,
            default() {
                return {
                    id: 0,
                    type: COURSE_TYPE_TRAINER,
                    date: '1900-01-01',
                    start_time: '00:00',
                    draft: 0,
                };
            },
        },
    },
    computed: {
        content() {
            if (this.course.type === COURSE_TYPE_TRAINER_SELF) {
                return '自我训练';
            }
            if (this.course.draft) {
                return '申请中';
            }
            return null;
        },
        date() {
            let date = formatters.formatDate(this.course.date);
            if (this.course.start_time) {
                date += formatters.formatTime(this.course.start_time);
            } else {
                date += '（具体时间待定）';
            }
            return date;
        },
    },
    components: {
        WeuiCell,
    },
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/course/Link.vue